// @ts-nocheck
import { rowsPerPageInit } from "../../utils/constants/paginationConstants";
import {
  APPROVE_EVENT_FAILURE,
  APPROVE_EVENT_FAILURE_BY_CLIENT_FAILURE,
  APPROVE_EVENT_REQUEST,
  APPROVE_EVENT_REQUEST_BY_CLIENT_REQUEST,
  APPROVE_EVENT_SUCCESS,
  APPROVE_EVENT_SUCCESS_BY_CLIENT_SUCCESS,
  EMPTY_CLIENT_ESTIMATE_LIST,
  FETCH_ESTIMATES_FAILURE,
  FETCH_ESTIMATES_REQUEST,
  FETCH_ESTIMATES_SUCCESS,
  FETCH_OLD_COMMENTS_FAILURE,
  FETCH_OLD_COMMENTS_REQUEST,
  FETCH_OLD_COMMENTS_SUCCESS,
  GET_ALL_SUBMITTED_ESTIMATES_FAILURE,
  GET_ALL_SUBMITTED_ESTIMATES_REQUEST,
  GET_ALL_SUBMITTED_ESTIMATES_SUCCESS,
  NEW_ESTIMATE_FAILURE,
  NEW_ESTIMATE_REQUEST,
  NEW_ESTIMATE_SUCCESS,
  POST_APPLIED_RATE_FAILURE,
  POST_APPLIED_RATE_REQUEST,
  POST_APPLIED_RATE_SUCCESS,
  POST_COMMENT_FAILURE,
  POST_COMMENT_REQUEST,
  POST_COMMENT_SUCCESS,
  REJECT_EVENT_FAILURE,
  REJECT_EVENT_REQUEST,
  REJECT_EVENT_SUCCESS,
} from "../constants/estimate";

const initialState = {
  estimates: [],
  comments: [],
  allEstimates: [],
  allEstimateLoading: false,
  searchString: "",
  isLoading: false,
  rateLoading: false,
  isNewEstimateRequestLoading: false,
  isApproveEventByClientLoading: false,
  isCommentsLoading: false,
  filtersData: null,
  rowsPerPage: rowsPerPageInit,
  currentPage: 1,
  totalPages: null,
  searchBy: [],
  loadingPositionsContractorRate: [],
};

const estimateReducer = (state = initialState, action) => {
  switch (action.type) {
    // fetch estimate events
    case FETCH_ESTIMATES_REQUEST:
      return {
        ...state,
        isLoading: true,
        searchString: action?.payload?.searchString,
        searchBy: action?.payload?.searchBy,
        rowsPerPage: action?.payload?.rowsPerPage,
        filtersDate: action?.payload?.filtersDate,
      };
    case FETCH_ESTIMATES_SUCCESS:
      return {
        ...state,
        estimates: action.payload?.events,
        totalPages: action.payload?.totalPages,
        currentPage: action.payload?.currentPage,
        isLoading: false,
      };
    case FETCH_ESTIMATES_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // fetch old comments
    case FETCH_OLD_COMMENTS_REQUEST:
      return {
        ...state,
        isCommentsLoading: true,
      };

    case FETCH_OLD_COMMENTS_SUCCESS:
      return {
        ...state,
        comments: action?.payload?.estimateChat,
        isCommentsLoading: false,
      };

    case FETCH_OLD_COMMENTS_FAILURE:
      return {
        ...state,
        isCommentsLoading: false,
      };

    // post comments
    case POST_COMMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case POST_COMMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        comments: action?.payload,
      };
    case POST_COMMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // post applied rate
    case POST_APPLIED_RATE_REQUEST:
      return {
        ...state,
        rateLoading: true,
        loadingPositionsContractorRate: [
          ...(state?.loadingPositionsContractorRate || []),
          ...(action?.payload || []),
        ],
      };
    case POST_APPLIED_RATE_SUCCESS:
      return {
        ...state,
        rateLoading: false,
        loadingPositionsContractorRate: [],
      };
    case POST_APPLIED_RATE_FAILURE:
      return {
        ...state,
        rateLoading: false,
        loadingPositionsContractorRate: [],
      };

    // approve event
    case APPROVE_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case APPROVE_EVENT_SUCCESS:
      return {
        ...state,
        // estimates: {
        //   ...state.estimates,
        //   events: state.estimates.events.map((event) => {
        //     if (event?._id !== action?.payload) return event;
        //   }),
        // },
        isLoading: false,
      };

    case APPROVE_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // approve event by client
    case APPROVE_EVENT_REQUEST_BY_CLIENT_REQUEST:
      return {
        ...state,
        isApproveEventByClientLoading: true,
      };

    case APPROVE_EVENT_SUCCESS_BY_CLIENT_SUCCESS:
      return {
        ...state,
        // estimates: {
        //   ...state.estimates,
        //   events: state.estimates.events.map((event) => {
        //     if (event?._id !== action?.payload) return event;
        //   }),
        // },
        isApproveEventByClientLoading: false,
      };

    case APPROVE_EVENT_FAILURE_BY_CLIENT_FAILURE:
      return {
        ...state,
        isApproveEventByClientLoading: false,
      };

    // reject event
    case REJECT_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case REJECT_EVENT_SUCCESS:
      return {
        ...state,
        // estimates: {
        //   ...state.estimates,
        //   events: state.estimates.events.map((event) => {
        //     if (event?._id !== action?.payload) return event;
        //   }),
        // },
        isLoading: false,
      };

    case REJECT_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // newEstimateRequest
    case NEW_ESTIMATE_REQUEST:
      return {
        ...state,
        isNewEstimateRequestLoading: true,
      };

    case NEW_ESTIMATE_SUCCESS:
      return {
        ...state,
        isNewEstimateRequestLoading: false,
      };

    case NEW_ESTIMATE_FAILURE:
      return {
        ...state,
        isNewEstimateRequestLoading: false,
      };

    case EMPTY_CLIENT_ESTIMATE_LIST:
      return {
        ...initialState,
      };

    // get all submitted estimate action
    case GET_ALL_SUBMITTED_ESTIMATES_REQUEST:
      return {
        ...state,
        allEstimateLoading: true,
      };

    case GET_ALL_SUBMITTED_ESTIMATES_FAILURE:
      return {
        ...state,
        allEstimateLoading: false,
        allEstimates: [],
      };

    case GET_ALL_SUBMITTED_ESTIMATES_SUCCESS:
      return {
        ...state,
        allEstimateLoading: false,
        allEstimates: action?.payload?.data?.filter(
          (item) => item?.estimateGeneratedAt,
        ),
      };

    // default
    default:
      return state;
  }
};

export default estimateReducer;
export { initialState };